<template>
  <div class="modal_card">
    <div class="header">
      <h4 class="title">
        {{ translate('tariffication.add_device_tariff') }}
      </h4>
    </div>
    <div class="content">

      <div class="row">
        <div class="col-md-10">
          <fg-input
              v-model="device_tariff.fid"
              type="text"
              :label="translate('tariffication.device_fid')"
              :placeholder="translate('tariffication.device_fid')"
          />
        </div>
        <div class="col-md-2">
          <button
              class="btn btn-success btn-fill mdi mdi-search-web search"
              @click.prevent="check_device()"
          />
        </div>
      </div>

      <div class="row" v-if="tariff_list.length > 0 && device_tariff.fid !== ''">
        <div class="col-md-8">
          <label> {{ translate('tariffication.tariff_name') }} </label>
          <tree-select
              :options="tariff_list"
              :multiple="false"
              v-model="device_tariff.tariff_id"
              :placeholder="translate('tariffication.tariff_name')"
              :clearable="false"
              :searchable="true"
              :max-height="200"
              ref="select_tariff"
          />
        </div>

        <div class="col-md-4">
          <WrapDatePicker
              v-model="device_tariff.date_start"
              type="date"
              :range="false"
              :confirm="false"
              value_type="YYYY-MM-DD"
              :disabled_date="['- 5 month', '+ 1 month']"
              :placeholder="translate('tariffication.date_start')"
              :label="translate('tariffication.date_start')"
          />
        </div>
      </div>

      <div class="row" v-if="tariff_list.length > 0 && device_tariff.fid !== ''">
        <div class="col-md-4">
          <div class="form-group">
            <label> {{ translate('tariffication.order_number') }} </label>
            <input
                type="text"
                class="form-control border-input error"
                v-model="device_tariff.order_id"
                :placeholder="translate('tariffication.order_number')"
            >
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label> {{ client_service.name }} </label>
            <input
                type="text"
                class="form-control border-input error"
                v-model="client_service.id"
                :placeholder="client_service.name"
                @input="validateInput"
            >
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <WrapDatePicker
                v-model="device_tariff.order_date"
                type="date"
                :range="false"
                :confirm="false"
                value_type="YYYY-MM-DD"
                :disabled_date="['- 2 month', '+ 1 month']"
                :placeholder="translate('tariffication.order_date')"
                :label="translate('tariffication.order_date')"
            />
          </div>
        </div>
      </div>

      <div class="row" v-if="tariff_list.length > 0 && device_tariff.fid !== ''">
        <div class="col-md-12">
          <div class="form-group">
            <label> {{ translate('tariffed_device.modal_complete_tariffication.activation_diadoc_url') }} </label>
            <input
                type="text"
                class="form-control border-input error"
                v-model="device_tariff.diadoc_url"
                :placeholder="translate('tariffed_device.modal_complete_tariffication.activation_diadoc_url')"
            >
          </div>
        </div>
      </div>

      <div class="row" v-if="tariff_list.length > 0 && device_tariff.fid !== ''">
        <div class="col-md-12">
          <label>{{ translate("tariffication.comment") + ", не более 512 символов" }}</label>
          <textarea
              v-model="device_tariff.comment"
              rows="5"
              class="form-control border-input"
              :placeholder="translate('tariffication.comment')"
              maxlength="512"
          />
        </div>
      </div>

      <div class="row" v-if="!result_not_null && device_tariff.fid !== ''">
        <div class="col-md-12">
          <p class="text-center">{{ translate("tariffication.no_available_tariff") }}</p>
        </div>
      </div>

      <div class="text-center buttons">
        <button
            class="btn btn-info btn-fill btn-wd"
            @click.prevent="add_device_tariff()"
            :disabled="!(device_tariff.tariff_id && device_tariff.date_start)"
        >
          {{ translate("btn.add") }}
        </button>
        <button
            class="btn btn-danger btn-fill btn-wd"
            @click.prevent="cancel"
        >
          {{ translate('close_modal') }}
        </button>
      </div>
      <div class="clearfix"/>
    </div>
  </div>
</template>
<script>

import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";

export default {
  name: "AddDeviceTariff",
  components: {WrapDatePicker},
  data() {
    return {
      tariff_list: [],
      result_not_null: true,

      device_tariff:{
        tariff_id: null,
        fid: "",
        date_start: "",
        comment: "",
        order_id: "",
        order_date: "",
        diadoc_url: ""
      },
      client_service: {
        id: null,
        name: ""
      }
    }
  },
  props: {
    params: {
      type: Object,
      default: () => ({})
    },
    prop_device_fid: {
      type: [String],
      default: ''
    }
  },

  created() {
    for (let key of ['date_start', 'order_date', 'order_id', 'diadoc_url', 'comment']) {
      if (this.params[key] !== undefined) this.device_tariff[key] = this.params[key]
    }
    if (this.prop_device_fid !== '') {
      this.device_tariff.fid = this.prop_device_fid
      this.check_device()
    }
  },

  watch: {
    "device_tariff.date_start":{
      handler(){
        if (this.device_tariff.date_start !== '' && this.device_tariff.order_date === '') {
          this.device_tariff.order_date = this.device_tariff.date_start
        }
      }
    },
    "device_tariff.fid": {
      handler(){
        if (this.device_tariff.fid === '') {
          this.clear_params()
        }
      }
    },
    "client_service.id":{
      handler(){
        if (String(this.client_service.id).length > 64) this.client_service.id = this.client_service.id.slice(0,64)
      }
    }
  },

  methods: {
    validateInput(e) {
      this.client_service.id = this.client_service.id.slice(0, 64)
    },
    clear_params() {
      this.tariff_list = []
      this.device_tariff.tariff_id = null
      this.device_tariff.date_start = ''
    },
    check_device() {
      if (this.device_tariff.fid !== '') {
        this.$http.v1.getDeviceAvailableTariffs(this.device_tariff.fid, (response) => {
          this.tariff_list = response.data.tariffs
          this.result_not_null = this.tariff_list.length > 0
          this.client_service.id = this.device_tariff.fid === this.prop_device_fid
              ? (this.params.client_service_id ?? this.params.service_id ?? response.data.client_service_info.client_service_id)
              : response.data.client_service_info.client_service_id
          this.client_service.name = response.data.client_service_info.client_service_name
          if (response.data.tariffs.length === 1) {
            this.device_tariff.tariff_id = response.data.tariffs[0].id
          }
          if (this.tariff_list.length > 0) {
            this.$nextTick(() => {
              this.$refs.select_tariff.openMenu()
              this.$refs.select_tariff.focusInput()
            })
          }
        })
      } else {
        this.clear_params()
      }
    },
    cancel() {
      this.$emit('close')
    },
    add_device_tariff() {
      const new_device_tariff = {
        ...this.device_tariff,
        client_service_id: this.client_service.id
      }
      this.$http.v1.addDeviceTariff(new_device_tariff, (response) => {
        this.global_notify('info', response.data.comment)
        this.$router.push('/tariffed_device/' + response.data.id)
        this.$emit('close')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.modal_card {
  width: 100%;
  border-radius: 3px;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
  color: #252422;
  position: relative;
  border: 1px solid #ccc;
  min-height: 85px;
  background-color: #f8f8f8;
  padding: 10px;

  .header {
    .title {
      margin-top: 5px;
      text-align: center;
    }
  }

  .content {
    .row {
      margin-bottom: 10px;
      display: flex;
      align-items: flex-end;
      justify-content: center;

      .mx-input {
        width: 100%;
      }

      .form-group {
        margin: 0;
      }

      .search{
        width: 100%;
        font-size: 18px;
      }

      button {
        height: 40px;
      }
    }

    .buttons {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
    }
  }
}

</style>
